import { useEffect, useState } from "react";
import { Power } from "@phosphor-icons/react";
import { endpoints } from "../lib/api";
import { toast } from "sonner";

export const BotToggle = ({ onChange }) => {
  const [state, setState] = useState({ bot_on: false, running: false, mode: "paper" });
  const [busy, setBusy] = useState(false);

  const refresh = async () => {
    try {
      const { data } = await endpoints.botStatus();
      setState(data);
      onChange?.(data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 5000);
    return () => clearInterval(id);
  }, []); // eslint-disable-line

  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await endpoints.botToggle();
      setState((s) => ({ ...s, ...data }));
      toast.success(data.bot_on ? "Bot STARTED" : "Bot STOPPED");
      onChange?.(data);
    } catch (e) {
      toast.error("Failed to toggle bot");
    } finally {
      setBusy(false);
    }
  };

  const on = state.bot_on;

  return (
    <div
      data-testid="master-bot-panel"
      className={`relative border border-border p-5 rounded-sm bg-[#0d0d0d] overflow-hidden`}
      style={{
        backgroundImage:
          "linear-gradient(135deg, rgba(59,130,246,0.03) 0%, rgba(0,0,0,0) 100%)",
      }}
    >
      <div className="flex items-center justify-between gap-6">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <span className={`w-2 h-2 rounded-full ${on ? "bg-signal-buy" : "bg-muted-foreground"}`} />
            <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              Master Control
            </span>
          </div>
          <div className="font-heading font-black text-3xl tracking-tight">
            {on ? "TRADING BOT ACTIVE" : "TRADING BOT OFFLINE"}
          </div>
          <div className="text-sm text-muted-foreground mt-1 font-mono">
            MODE: <span className="text-white">{(state.mode || "paper").toUpperCase()}</span>
            {" · "}
            LOOP:{" "}
            <span className={state.running ? "text-signal-buy" : "text-signal-sell"}>
              {state.running ? "RUNNING" : "STOPPED"}
            </span>
          </div>
        </div>
        <button
          data-testid="bot-toggle-btn"
          onClick={toggle}
          disabled={busy}
          className={`relative w-32 h-32 rounded-full border-2 flex flex-col items-center justify-center transition-all ${
            on
              ? "border-signal-buy bg-signal-buy/10 glow-buy text-signal-buy"
              : "border-border bg-[#0a0a0a] text-muted-foreground hover:border-signal-brand hover:text-signal-brand"
          } ${busy ? "opacity-50 cursor-wait" : "cursor-pointer"}`}
        >
          <Power size={40} weight={on ? "fill" : "bold"} />
          <span className="font-mono text-[10px] font-bold uppercase mt-2 tracking-widest">
            {on ? "ON" : "OFF"}
          </span>
        </button>
      </div>
    </div>
  );
};

export default BotToggle;
